export interface IVoiceDetails {
    fromNumber: string;
    cli: string;
    costCentre: string;
    name: string;
}

export interface IVoiceActions {
    muted: boolean;
    enablePayments: boolean;
    enableDTMFKeypad: boolean;
}

export interface IVoiceAction {
    actionName: keyof IVoiceActions;
    value: boolean;
}

export interface IVoiceTask {
    details: IVoiceDetails;
    actions: IVoiceActions;
}

export interface IVoiceTasks {
    voiceTasks: Record<string, IVoiceTask>;
    previousActions: Record<string, IVoiceActions>;
}

export class VoiceTask implements IVoiceTask {
    details = {
        fromNumber: '',
        cli: '',
        costCentre: '',
        name: '',
    };

    actions = {
        muted: false,
        enablePayments: false,
        enableDTMFKeypad: false,
    };

    get(): IVoiceTask {
        return {
            details: this.details,
            actions: this.actions,
        };
    }

    update(voiceTask: Partial<IVoiceTask>): void {
        this.details = voiceTask.details
            ? { ...this.details, ...voiceTask.details }
            : this.details;
        this.actions = voiceTask.actions
            ? { ...this.actions, ...voiceTask.actions }
            : this.actions;
    }
}
